import Vue from 'vue'
import { mapState } from 'vuex'
import DropdownDatepicker from '@/components/dropdown-datepicker/dropdown-datepicker.vue'

export default Vue.extend({
  name: 'Register',

  components: {
    DropdownDatepicker
  },

  data() {
    return {
      registerForm: {
        nickName: '',
        birth: '',
        email: '',
        password: '',
        confirmPassword: '',
        answerChoice: null,
        answerNote: null,
        checked: false
      },
      isShow: true,
      answers: [
        {
          name: 'Web検索（Googleなどで、IT資格名での検索）',
          value: 1
        },
        {
          name: 'SNS（Twitter,Facebookなど）',
          value: 2
        },
        {
          name: '知人の紹介',
          value: 3
        },
        {
          name: 'LPI-Japanの認定教材ページ',
          value: 4
        },
        {
          name: 'LPI-Japanのメールマガジン',
          value: 5
        },
        {
          name: 'その他',
          value: 9
        }],
      isLoaded: false,
      valid: false,
      error: '',
      required(propertyType: any) {
        return (v: string) =>
          (v && v.length > 0) || `${propertyType}は入力必須項目です`
      },
      minLength(min_value: number) {
        return (v: string) =>
          (v && v.length >= min_value) || `${min_value}文字以上で入力してください`
      },
      maxLength(max_value: number) {
        return (v: string) =>
            (v && v.length <= max_value) || `${max_value}文字未満で入力してください`
      },
      confirmPassword() {
        return (password: string) =>
          password === this.registerForm.password || `パスワードが一致しません`
      },
      validEmail() {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return (v: string) =>
          (v && re.test(v)) || `正しいメールアドレスを入力してください`
      },
      preventJapaneseText() {
        let japanRegex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g
        return (v: any) =>
          (v && !japanRegex.test(v)) || '半角英数字、及び記号のみで入力してください。'
      },
      answerNoteErrMsg: ''
    }
  },

  created() {
    this.$store.dispatch('clearMessage')
  },

  computed: {
    ...mapState(['loading', 'message']),
    passwordConfirmationRule() {
      return () => (this.registerForm.password === this.registerForm.confirmPassword)
    },
    uniqueEmail() {
      return () => (!this.error && this.error.length === 0) || 'このメールアドレスは既に登録されています'
    }
  },

  methods: {
    isShowInput(event: any) {
      if (event === 9) {
        this.isShow = false
      } else {
        this.isShow = true
        this.registerForm.answerNote = null
      }
    },
    handleRegister() {
      const { answerChoice, answerNote } = this.registerForm
      if (answerChoice === 9 && !answerNote) {
        this.answerNoteErrMsg = 'お手数ですが「その他」の場合は内容を入力してください'
        return
      }
      this.$store.dispatch('clearMessage')
      this.$store.dispatch('loading')
      this.isLoaded = true
      this.$nextTick(async () => {
        let res = await this.$store.dispatch('register', this.registerForm)
        this.error = res.errors ? res.errors.length > 0 ? res.errors : '' : ''
        this.isLoaded = false
      })
      this.$store.dispatch('loading', false)
    },

    handleLogin() {
      this.$router.push({ path: '/login' })
    },

    handleTerms() {
      window.open(process.env.VUE_APP_TERMS_OF_SERVICE, '_blank')
    },
    handlePersonalTerm() {
      window.open('https://polaristation.com/agree-privacy-policy/', '_blank')
    },
    clearError() {
      this.error = ''
    },
    preventJapaneseInput(e: any) {
      let japanRegex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g
      if (japanRegex.test(e.key)) {
        e.preventDefault()
      }
    }
  }
})
